import { Map } from "immutable"
import { returnStateIfNoAction } from "../helpers"
import actionTypes from "../../actions/actionTypes"

const INIT_STATE = Map({
    sortPerformances: null
})

const generalSettingsReducer = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PRINT_DATA_GET_SUCCESS:
            return state.set('movieTimesPrint', action.payload.generalSettings.movieTimesPrint);
        default:
            return state;
    }

}

export default generalSettingsReducer